// extracted by mini-css-extract-plugin
export default {"secondColumn":"SpecialRequestDetailsModal_secondColumn__NsBK1"};